<template>
	<!--主体-开始-->
	<div class="LogB" id="login">
		<article class="IndCon">
			<section class="LogLogo flexC fl-cen">
				<h3 class="LogTit">
					<!-- <img src="@/assets/wap/images/icon/logo.png"> -->
					{{$t('message.login')}}
				</h3>
			</section>
			<!--登录-开始-->
			<!-- <van-tabs type="line" background="#e0eafd" title-active-color="#fff" title-inactive-color="#6c6c6c"
				color="#015ae8">
				<van-tab :title="$t('message.accountlogin')"> -->
			<van-form @submit="onSubmit">
				<div class="TcLogF TcLogK Huans">
					<div class="TcLogFD">
						<!-- <div class="TcLogFH">账户名</div> -->
						<!-- <div class="boxradius TcLogFS flexC fl-bet">
									<van-field :label="$t('message.username1')" name="username" v-model="username" placeholder=""
										:border="false" autocomplete="off" class="LogI name"
										:rules="[{ required: true, message: $t('message.usernametips') }]" />
								</div> -->
						<div class="boxradius userID TcLogFS flexC fl-bet">
							<van-field :label="$t('message.phone')+'/'+$t('message.userID')" type="tel" name="mobile"
								v-model="mobile" placeholder="" :border="false" autocomplete="off"
								class="TcLogFI Huans name" />
							<div class="iconfontll icon-shouji"></div>
						</div>
						<!-- 			<div class="boxradius TcLogFS flexC fl-bet">
									<van-popover v-model="showPopover" trigger="click" :actions="actions"
										:close-on-click-outside="false" :overlay="true" @select="onSelect">
										<template #reference>
											<div class="PhoneInput_dropdown">
												<div class="PhoneInput flexC fl-bet Huans">
													<div class="PhoneInput_icon__2rYuk">{{countrys[cindex].code}}</div>
													<img src="@/assets/wap/images/icon/Bro-sel.png"
														:class="{ 'icon_down_rolate': flag }">
												</div>
											</div>
										</template>
									</van-popover>
									<div class="TcLogFS_inp flexC fl-bet">
										<van-field type="tel" name="mobile" v-model="mobile"
											placeholder="" :border="false" autocomplete="off"
											class="TcLogFI Huans name"
											:rules="[{ required: true, message: $t('message.pleasemobile') }]" />
											<div class="iconfontll icon-shouji"></div>
									
									</div>
								</div> -->
					</div>
					<div class="TcLogFD">
						<!-- <div class="TcLogFH">密码</div> -->
						<div class="boxradius TcLogFS flexC fl-bet">
							<van-field type="number" name="password" :label="$t('message.password')" :type="pass_type"
								v-model="password" placeholder="" :border="false" autocomplete="off"
								class="TcLogFI Huans password"
								:rules="[{ required: true, message: $t('message.pleasepass') }]" />
							<!-- 查看密码 -->
							<!-- <div class="TceyeI" :class="{ 'Tchide': pass_type=='password' }" @click="eyeBtn()">
									</div> -->
							<div class="LogFor_box">
								<router-link :to="{name: 'find'}" class="LogForC">{{$t('message.forget')}}？
								</router-link>
							</div>
							<div class="iconfontll icon-jiesuo"></div>
						</div>
					</div>
					<!-- <div class="TcLogFD">
								<div class="TcLogFH">验证码</div>
								<div class="boxradius TcLogFS flexC fl-bet">
									<van-field type="number" name="twcode" :label="$t('message.yzm')" v-model="twcode"
										placeholder="" :border="false" autocomplete="off"
										class="LogI yzm"
										:rules="[{ required: true, message: $t('message.pleasetwcode') }]" />
									<div class="LogDNa" @click="refreshCode"><img :src="imgcode"></div>
									<div class="iconfontll icon-yanzhengma"></div>
								</div>
							</div> -->
					<!-- <div class="TcLogFD flexC fl-bet">
						<label class="Logla flexC">
							<van-checkbox name="checkbox" v-model="checked">{{$t('message.remember')}}
							</van-checkbox>
						</label> -->
					<!-- 忘记密码 -->
					<!-- <router-link :to="{name: 'find'}" class="LogForC">{{$t('message.forget')}}？
								</router-link> -->
					<!-- </div> -->
					<div class="Logbt">
						<van-button :disabled="submitStatus" :loading="submitStatus" :loading-text="$t('message.login')"
							round block type="info" native-type="submit" class="LogBut">
							{{$t('message.login')}}
						</van-button>
					</div>
					<div class="Logdc flexC fl-cen">
						<p>{{$t('message.noaccount')}}？</p>
						<router-link :to="{name: 'register'}" class="LogC">{{$t('message.register1')}}
						</router-link>
					</div>
					<div class="Logdc flexC fl-cen">
						<router-link v-if="isHideVideo" to="/games"
							class="Logfhbtn">{{$t('message.returnhome')}}</router-link>
						<router-link v-else to="/index" class="Logfhbtn">{{$t('message.returnhome')}}</router-link>
					</div>
				</div>
			</van-form>
			<!-- 				</van-tab>
				<van-tab :title="$t('message.mobilelogin')">
					<van-form @submit="onSubmit2">
						<div class="TcLogF TcLogK Huans">
							<div class="TcLogFD">
								<div class="TcLogFH">{{$t('message.country')}}</div>
								<div class="TcLogFS flexC fl-bet">
									<van-popover v-model="showPopover" trigger="click" :actions="actions"
										:close-on-click-outside="false" @select="onSelect">
										<template #reference>
											<div class="PhoneInput_dropdown">
												<div class="PhoneInput flexC fl-bet Huans">
													<div class="PhoneInput_icon__2rYuk">{{countrys[cindex].code}}</div>
													<img src="@/assets/wap/images/icon/Bro-sel.png"
														:class="{ 'icon_down_rolate': flag }">
												</div>
											</div>
										</template>
									</van-popover>
									<div class="TcLogFS_inp flexC fl-bet">
										<van-field type="tel" name="mobile" v-model="mobile"
											:placeholder="$t('message.pleasemobile')" :border="false" autocomplete="off"
											class="TcLogFI Huans name"
											:rules="[{ required: true, message: $t('message.pleasemobile') }]" />
									
									</div>
								</div>
							</div>
							<div class="TcLogFD">
								<div class="TcLogFH">{{$t('message.yzm')}}</div>
								<div class="TcLogFS flexC fl-bet">
									<div class="TcLogFS_inp flexC fl-bet">
										<van-field type="number" name="code" v-model="code"
											:placeholder="$t('message.pleaseyzm')" :border="false" autocomplete="off"
											class="TcLogFI Huans yzm"
											:rules="[{ required: true, message: $t('message.pleaseyzm') }]" />
									</div>
									<div class="flexC fl-bet">
										<input type="button" class="LogFoz" :value="$t('message.sendcode')"
											@click="clickButton()" v-show="yzm">
										<div class="LogFoz" v-show="djs">
											<van-count-down ref="countDown" :time="60000" :auto-start="false"
												format="ss" @finish="finish" />
										</div>
									</div>
								</div>
							</div>
							<div class="Logbt">
								<van-button round block type="info" native-type="submit" class="LogBut">
									{{$t('message.login')}}</van-button>
							</div>
							<div class="Logdc flexC fl-cen">
								<p>{{$t('message.noaccount')}}？</p>
								<router-link :to="{name: 'register'}" class="LogC">{{$t('message.register')}}
								</router-link>
								<router-link to="/index" class="LogFH">{{$t('message.returnhome')}}</router-link>
							</div>
						</div>
					</van-form> -->
			<!-- 		</van-tab>
			</van-tabs> -->
			<!--登录-结束-->
			<!-- <section class="LogFt" style="position: fixed;bottom: 0;left: 0;right: 0;margin:0 auto"
				v-show="hidshow||!isAndroid">
				<div class="LogFtD flexC fl-cen">
					<a href="javascript:;" class="LogFtI"><img src="@/assets/wap/images/icon/LogFt01.png"></a>
					<a href="javascript:;" class="LogFtI"><img src="@/assets/wap/images/icon/LogFt02.png"></a>
				</div>
				<div class="LogFtH">{{$t('message.bottomtips')}}</div>
			</section> -->
		</article>
	</div>
	<!--主体-结束-->
</template>

<script>
	import {
		getHideVideo
	} from "@/assets/wap/js/hideJs";
	import {
		postLogin,
		sendSms,
		getAreaCodes
	} from "@/api/urls";
	export default {
		name: 'login',
		data() {
			return {
				isHideVideo: false, //是否隐藏视频
				username: '',
				password: '',
				mobile: '',
				code: '',
				pass_type: 'password',
				checked: true,
				showPopover: false,
				actions: [
					// { text: '南非+27', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '阿曼+968', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '缅甸+96', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '约旦+962', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '新西兰+64', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '尼日利亚+234', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '玻利维亚+591', icon: require('@/assets/wap/images/icon/icon99.png') },
					// { text: '伊朗+98', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '乌克兰+380', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '罗马尼亚+40', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '乔治亚州+995', icon: require('@/assets/wap/images/icon/icon99.png')},
					// { text: '摩洛哥+212', icon: require('@/assets/wap/images/icon/icon99.png')},
				],
				flag: false,
				yzm: true, //发送验证码
				djs: false,
				twcode: '', //图文验证码
				imgcode: '', //图形验证码图片
				countrys: [{
					nameEn: "USA",
					nameCn: "美国",
					code: "+1"
				}], //国家数组
				cindex: 0, //选中的第几个
				docmHeight: '0', //初始状态可视区高度
				showHeight: '0', //实时可视区高度
				hidshow: true, //是否显示底部
				isAndroid: false, //是否为安卓系统
				codeStatus: false, //按钮状态
				submitStatus: false, //按钮状态
			}
		},
		created() {
			this.isHideVideo = this.$store.state.isHideVideo;
			this.getAreaCodes(); //国家手机号
			//仅针对安卓做处理，不然的话ios会出现新的问题
			var u = navigator.userAgent;
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
			if (isAndroid) {
				this.isAndroid = true;
			} else {
				this.isAndroid = false;
			}
			this.docmHeight = document.documentElement.clientHeight
		},
		mounted() {
			// 获取当前可视区域的高度
			// let height = document.documentElement.clientHeight
			// window.onresize = () => { // 在页面大小发生变化时调用
			//   // 把获取到的高度赋值给根div
			//   document.getElementById('login').style.height = height + 'px'
			// }
			window.onresize = () => {
				return (() => {
					this.showHeight = document.body.clientHeight
					if (this.docmHeight > this.showHeight) {
						this.hidshow = false
					} else {
						this.hidshow = true
					}
				})()
			}
		},
		methods: {
			eyeBtn() {
				var type = this.pass_type;
				if (type == 'password') {
					this.pass_type = 'text';
				} else {
					this.pass_type = 'password';
				}
			},
			//图文验证码
			getImgCode() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryImgcode(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.imgcode = data.imageCode;
					}
				})
			},
			refreshCode() {
				this.getImgCode();
			},
			// 获取国家手机号
			getAreaCodes() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getAreaCodes(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.countrys = data;
						var actions = [];
						data.map((item, index) => {
							var conts = {
								text: item['label'] + item['value']
							};
							actions.push(conts);
						})
						this.actions = actions;
						// this.country = actions[0];
					}
				})
			},
			//提交
			onSubmit(values) {
				this.submitStatus = true;
				console.log('submit', values);
				console.log(this.checked);
				var params = {
					"username": values['mobile'],
					"password": values['password'],
				}
				postLogin(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.$toast('登录成功');
						console.log(data, '登录成功')
						this.$store.commit('setToken', data)
						// this.$store.commit('setUserInfo', data.user)
						this.$store.commit('setIslookpop',false)
						this.submitStatus = false;
						setTimeout(() => {
							getHideVideo(1) //隐藏视频公共js
						}, 2000)
					} else {
						this.$toast(msg);
						this.submitStatus = false;
						return false;
					}
				})
			},
			onSubmit2(values) {
				this.submitStatus = true;
				console.log('submit', values);
				var params = {
					"captcha": values['code'],
					"phone": values['mobile'],
					"countryCode": this.countrys[this.cindex]['value'],
					"dialCode": this.countrys[this.cindex]['value']
				}
				postLoginSms(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.$toast('登录成功');
						this.$store.commit('setToken', data.token)
						this.$store.commit('setUserInfo', data.user)
						this.$store.commit('setIslookpop',false)
						this.submitStatus = false;
						setTimeout(() => {
							getHideVideo(1) //隐藏视频公共js
						}, 2000)
					} else {
						this.$toast(msg);
						this.submitStatus = false;
						return false;
					}
				})
			},
			//选择国家手机号
			onSelect(action, index) {
				console.log(action)
				console.log(index)
				// this.country = this.actions[index];
				this.cindex = index;
			},
			//开始倒计时
			clickButton() {
				if (this.mobile == '') {
					this.$toast('请先输入手机号');
					return false;
				}
				sendSms({
					'code': this.countrys[this.cindex]['value'], //手机国家区号
					'phone': this.mobile
				}).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						this.yzm = false;
						this.djs = true;
						this.$nextTick(() => {
							this.$refs.countDown.start();
						});
					} else {
						this.$toast(msg);
					}
				})
			},
			//结束倒计时
			finish() {
				this.yzm = true;
				this.djs = false;
				this.$refs.countDown.reset();
			}
		}
	}
</script>

<style lang="less" scoped>
	#login .van-tabs--line .van-tabs__wrap {
		height: 40px;
	}

	#login .van-tabs__nav--line {
		width: 80%;
		margin-left: 10%;
	}

	#login .van-tab--active {
		background: #025be8;
	}

	#login .van-tab {
		border-radius: 5px;
	}

	#login .van-cell {
		background-color: rgba(0, 0, 0, 0);
		padding: 10px 0px;
	}

	#login .van-field__control::placeholder {
		color: #777;
		font-size: 14px;
	}

	#login .van-field__control::-webkit-input-placeholder {
		color: #777;
		font-size: 14px;
	}

	#login .van-field__control::-moz-placeholder {
		color: #777;
		font-size: 14px;
	}

	#login .van-field__control::-ms-input-placeholder {
		color: #777;
		font-size: 14px;
	}

	#login .van-field--error .van-field__control::-webkit-input-placeholder {
		color: #ee0a24;
	}

	#login .van-field--error .van-field__control::-moz-placeholder {
		color: #777;
		font-size: 14px;
	}

	#login .van-field--error .van-field__control::-ms-input-placeholder {
		color: #777;
		font-size: 14px;
	}

	#login .van-tabs__line {
		display: none;
	}

	// 修改
	.LogB {
		min-height: 100vh;
		// background-image: url("../../assets/wap/images/my/bg1.jpg");
		// background-position: center center;
		// background-repeat: no-repeat;
		// background-size: cover;
		// background-color: var(--login-bgcolor);
		background-color: var(--bg-color);
	}

	.LogBut {
		color:#fff;
		border: none;
		background-color: #FFBC41;
	}

	.darkmode .LogBut {
		color:var(--menu-color);
		background-color: var(--anbut-bgcolor);
	}

	.boxradius {
		padding: 0.05rem 0.15rem;
		color:var(--hfont-color);
		// color:var(--menu-color);
		// background-color: rgba(0, 0, 0, 0.2);
		// background-color: var(--login-color);
		background-color: var(--search-color);
		border-radius: 100px;

		/deep/ .van-field__label {
			width: 5em;
			color:var(--hfont-color);
		}
	}

	.userID {
		/deep/ .van-field__label {
			width: 6.8em;
			color:var(--hfont-color);
		}
	}

	/deep/ .van-checkbox__label {
		color:var(--hfont-color);
	}

	/deep/ .van-cell__value--alone {
		color:var(--hfont-color);
	}

	/deep/ .van-field__control {
		color:var(--hfont-color)!important;
	}

	/deep/ .van-cell {
		height: auto;
		line-height: inherit;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.LogFor_box {
		background-color: rgba(0, 0, 0, 0.2);
		// background-color: var(--logincode-color);
		padding: 0.05rem 0.06rem;
		margin-right: 0.1rem;
		border-radius: 5px;

		.LogForC {
			color:var(--menu-color);
			font-size: 0.05rem;
		}
	}

	.PhoneInput {
		color:var(--font-color);
		width: 0.4rem;
	}

	.Logdc p {
		color:var(--font-color);
		font-size: 0.12rem;
		line-height: 0.18rem;
	}

	.LogTit {
		color:var(--font-color);
		font-size: 0.16rem;
	}

	.LogC {
		color:var(--font-color);
		font-size: 0.12rem;
		line-height: 0.18rem;
	}

	.Logfhbtn {
		margin-top: 10px;
		padding: 2px 20px;
		color:var(--font-color);
		font-size: 0.1rem;
		border: 1px solid var(--greybtn-bgcolor);
		border-radius: 5px;
	}

	.TcLogFS {
		margin: 0 0.1rem;
		height: 0.3rem;
		border-bottom: 0 solid #d9d4d4;
	}

	.iconfontll {
		font-size: 0.16rem;
	}

	.TcLogFS {
		margin: 0 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/wap/public/login.vue